import React from "react";
import { connect } from "react-redux";
import {
  fetchContacts,
  fetchUserCompany,
  addRequestWithFiles,
} from "../../store/actions/index";
import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import moment from "moment";
import UploadZone from "./UploadZone.js";
import { isRestricted } from "../../store/utility.js";

import {
  Breadcrumb,
  Button,
  FormGroup,
  Col,
  FormControl,
  ControlLabel,
  Form,
  Panel,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RequestContact from "../../components/UI/Widget/RequestContact";

class NewRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: true,
      error: null,
      requestResume: { value: "", isValid: true, message: "" },
      name: { value: "", isValid: true, message: "" },
      section: { value: "", isValid: true, message: "" },
      aknowledgement: { value: true, isValid: true, message: "" },
      creationDate: { value: moment(), isValid: true, message: "" },
      contacts: [],
      selectedContacts: [],
      request: null,
      isSending: false,
      files: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { request } = nextProps;
    const { contacts, loaded } = this.state;
    
    if (request && request.redirectTo) {
      this.props.history.push(nextProps.request.redirectTo);
    }
    if (nextProps.contacts && contacts !== nextProps.contacts) {
      this.setState({ contacts: nextProps.contacts });
    }
    if (loaded !== nextProps.loaded) {
      this.setState({ loaded: nextProps.loaded });
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchContacts());
    this.props.dispatch(fetchUserCompany());
  }

  switchHandler = (event) => {
    var state = this.state;
    state[event.target.id].value = !state[event.target.id].value;
    this.setState(state);
  };

  inputChangeHandler = (event) => {
    var state = this.state;
    state[event.target.id].value = event.target.value;
    this.setState(state);
  };

  validateForm = () => {
    return (
      this.state.name.value.length > 0 &&
      this.state.requestResume.value.length > 0 &&
      this.state.selectedContacts.length > 0
    );
  };

  submitHandler = (event) => {
    event.preventDefault();
    let _contacts = [];
    const { selectedContacts } = this.state;

    for (let selectedContact of selectedContacts) {
      let contact = {};
      if (selectedContact.value === selectedContact.label) {
        contact = {
          id: null,
          email: selectedContact.label,
        };
      } else {
        contact = {
          id: selectedContact.value,
          email: selectedContact.label,
        };
      }
      _contacts.push(contact);
    }
    //console.log("Sections");
    //console.log(this.props.company.sections);
    //console.log(this.state.section);
    const section = isRestricted() ? this.props.company.sections[0].label : this.state.section.value;
    var _request = {
      name: this.state.name.value,
      request: this.state.requestResume.value,
      section: section,
      contacts: _contacts,
    };

    const data = new FormData();
    const { files } = this.state;
    
    for (let f of files) {
      data.append("files", f);//files[i]);
    }
    const json = JSON.stringify(_request);
    const blob = new Blob([json], { type: "application/json" });
    data.append("request", blob);

    this.props.dispatch(addRequestWithFiles(data));
    this.setState({ isSending: true });
  };

  buildOptions(sections) {
    sections.sort((a, b) => a.label.trim().localeCompare(b.label.trim(), "fr-FR"));
    return sections.map(function (section, index) {
      if (section.enabled)
        return (
          <option key={index} value={section.label}>
            {section.label}
          </option>
        );
      return null;
    });
  }

  setContacts = (contacts) => {
    this.setState({ selectedContacts: contacts });
  };

  setFiles = (files) => {
    this.setState({ files: files });
  };

  render() {
    const requestDate = this.state.creationDate.value;
    if (!this.props.company || this.state.loaded) {
      return null;
    }
    const { company } = this.props;
    const { isSending } = this.state;
    const createDateLbl = requestDate.format('YYYY-MM-DD')
    return (
      <div className="content-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item href="/#/requests">Interventions</Breadcrumb.Item>
          <Breadcrumb.Item active>Nouvelle demande</Breadcrumb.Item>
        </Breadcrumb>
        <Panel>
          <Panel.Body>
            <Form onSubmit={this.submitHandler} horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>Titre *</Col>
                <Col sm={10}>
                  <FormControl
                    type="text"
                    value={this.state.name.value}
                    id="name"
                    className="form-control"
                    onChange={(event) => this.inputChangeHandler(event)}
                    placeholder="Renseignez le titre de votre demande d'intervention"
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>Société</Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    className="form-control"
                    disabled
                    value={company.name}
                  />
                </Col>
                {company.sections.length > 0 ? (
                  <Col componentClass={ControlLabel} sm={2}>
                    Site
                  </Col>
                ) : null}
                {company.sections.length > 0 ? 
                  isRestricted() ? (
                    <Col sm={4}>
                      <FormControl
                        type="text"
                        className="form-control"
                        disabled
                        value={company.sections[0].label}
                    />
                    </Col>
                  )
                  : (<Col sm={4}>
                    <FormControl
                      componentClass="select"
                      placeholder="Site"
                      id="section"
                      onChange={(event) => this.inputChangeHandler(event)}
                      value={this.state.section.value}
                    >
                      <option value="" />
                      {this.buildOptions(company.sections)}
                    </FormControl>
                  </Col>
                ) : null}
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>Créée le</Col>
                <Col sm={4}>
                  <FormControl
                    type="date"
                    className="form-control"
                    disabled
                    value={createDateLbl}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={3}>
                  Accusé de reception
                </Col>
                <Col sm={3}>
                  <label className="switch">
                    <FormControl
                      id="aknowledgement"
                      type="checkbox"
                      defaultChecked
                      onChange={(event) => this.switchHandler(event)}
                      value={this.state.aknowledgement.value}
                    />
                    <em />
                  </label>
                </Col>
              </FormGroup>
              {this.state.aknowledgement.value ? (
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={2}>Envoyé à *</Col>
                  <Col sm={10}>
                    <RequestContact
                      contacts={this.state.contacts}
                      requestContacts={[]}
                      setContacts={(value) => this.setContacts(value)}
                      canUpdate={true}
                    />
                  </Col>
                </FormGroup>
              ) : null}

              <FormGroup>
                <Col sm={9}>
                  <Panel style={{ marginBottom: "0px" }}>
                    <Panel.Heading>
                      <Panel.Title>Résumé de la demande *</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <textarea
                        rows="10"
                        id="requestResume"
                        className="form-control note-editor"
                        onChange={(event) => this.inputChangeHandler(event)}
                        value={this.state.requestResume.value}
                      />
                    </Panel.Body>
                  </Panel>
                </Col>
                <Col sm={3}>
                  <UploadZone setFiles={(values) => this.setFiles(values)} />
                </Col>
              </FormGroup>
              {!this.validateForm() ? (
                <span style={{ fontWeight: "bold", color: "red" }}>
                  * Les champs &quot;Titre&quot;, &quot;Envoyé à&quot; et
                  &quot;Resumé de la demande&quot; sont obligatoires
                </span>
              ) : null}

              <Button
                type="submit"
                disabled={!this.validateForm() || isSending}
                className="btn btn-block btn-primary mt-lg"
              >
                <span className="fa fa-send" />
                &nbsp;Envoyer
              </Button>
            </Form>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    error: state.contact.error,
    contacts: state.contact.contacts.filter((c) => c.enabled === true),
    loaded: state.contact.loading || state.auth.loading,
    company: state.auth.company,
    request: state.request,
  };
};

export default connect(mapStateToProps)(withErrorHandler(NewRequest, axios));


// WEBPACK FOOTER //
// ./src/containers/Request/NewRequest.js